unit Search.FuelType;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, XData.Web.Client, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls;

type
  TfrmFuelTypeSearch = class(TWebForm)
    WebPanel1: TWebPanel;
    WebPanel2: TWebPanel;
    WebPanel3: TWebPanel;
    dgFuelTypes: TTMSFNCDataGrid;
    wdsFuelTypes: TXDataWebDataSet;
    dsFuelTypes: TWebDataSource;
    wcFuelTypes: TXDataWebClient;
    dgdbaFuelType: TTMSFNCDataGridDatabaseAdapter;
    WebButton1: TWebButton;
    WebButton2: TWebButton;
    wdsFuelTypesfueltype: TIntegerField;
    wdsFuelTypesfueltypename: TStringField;
    weSearch: TWebEdit;
    procedure WebFormShow(Sender: TObject);
    procedure dgFuelTypesCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure weSearchChange(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iFuelTypeSearch : Integer;
    sFuelTypeNameSearch : String;
  end;

var
  frmFuelTypeSearch: TfrmFuelTypeSearch;

implementation

{$R *.dfm}
uses
stfmssystem.connection ,  share.common;

procedure TfrmFuelTypeSearch.dgFuelTypesCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  iFuelTypeSearch := dgdbaFuelType.FieldAtColumn[0].AsInteger;
  sFuelTypeNameSearch := dgdbaFuelType.FieldAtColumn[1].AsString;
end;

procedure TfrmFuelTypeSearch.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmFuelTypeSearch.WebButton2Click(Sender: TObject);
begin
  iFuelTypeSearch := 0;
  sFuelTypeNameSearch := '';
  Close;
end;

procedure TfrmFuelTypeSearch.WebFormShow(Sender: TObject);
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsFuelTypes.Close;
      wdsFuelTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsFuelTypes.Open;
    end;

begin
  wcFuelTypes.RawInvoke('IstfmsdieselService.Get_FuelTypes_View',[-1,0],@OnSuccess,@OnError);
end;

procedure TfrmFuelTypeSearch.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case dgFuelTypes.Selection.StartCell.Column of
        0 : wdsFuelTypes.Locate('fueltype', weSearch.Text, [loPartialKey]);
        1 : wdsFuelTypes.Locate('fueltypename', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

end.
